import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
  Module, 
  CreateModuleRequest, 
  UpdateModuleRequest, 
  AssignModuleToTenantRequest,
  TenantModule 
} from '../models/module.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllModules(): Observable<Module[]> {
    return this.http.get<Module[]>(`${this.API_URL}/modules`);
  }

  getModuleById(id: string): Observable<Module> {
    return this.http.get<Module>(`${this.API_URL}/modules/${id}`);
  }

  getModuleBySlug(slug: string): Observable<Module> {
    return this.http.get<Module>(`${this.API_URL}/modules/slug/${slug}`);
  }

  createModule(module: CreateModuleRequest): Observable<Module> {
    return this.http.post<Module>(`${this.API_URL}/modules`, module);
  }

  updateModule(id: string, module: UpdateModuleRequest): Observable<Module> {
    return this.http.patch<Module>(`${this.API_URL}/modules/${id}`, module);
  }

  deleteModule(id: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/modules/${id}`);
  }

  getModuleStats(id: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/modules/${id}/stats`);
  }

  // Module Assignment Methods
  assignModuleToTenant(tenantId: string, assignment: AssignModuleToTenantRequest): Observable<TenantModule> {
    return this.http.post<TenantModule>(`${this.API_URL}/modules/assign-to-tenant/${tenantId}`, assignment);
  }

  unassignModuleFromTenant(tenantId: string, moduleId: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/modules/unassign-from-tenant/${tenantId}/${moduleId}`);
  }

  updateModuleAssignment(tenantId: string, moduleId: string, updateData: Partial<AssignModuleToTenantRequest>): Observable<TenantModule> {
    return this.http.patch<TenantModule>(`${this.API_URL}/modules/update-assignment/${tenantId}/${moduleId}`, updateData);
  }

  updateTenantModuleAssignment(tenantId: string, moduleId: string, updateData: Partial<AssignModuleToTenantRequest>): Observable<TenantModule> {
    return this.http.patch<TenantModule>(`${this.API_URL}/modules/update-assignment/${tenantId}/${moduleId}`, updateData);
  }

  getTenantModules(tenantId: string): Observable<TenantModule[]> {
    return this.http.get<TenantModule[]>(`${this.API_URL}/modules/tenant/${tenantId}`);
  }

  getAvailableModules(tenantId: string): Observable<Module[]> {
    return this.http.get<Module[]>(`${this.API_URL}/modules/available/${tenantId}`);
  }
}
